import * as React from "react";
import { Accordion as AccordionPrimitive } from "radix-ui";
import { cn } from "@/shared/utils/utils";

const Accordion = ({
  ...props
}: React.ComponentProps<
  typeof AccordionPrimitive.Root
>): React.ReactElement => {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
};

const AccordionItem = ({
  className,
  ...props
}: React.ComponentProps<
  typeof AccordionPrimitive.Item
>): React.ReactElement => {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn("border-b last:border-b-0", className)}
      {...props}
    />
  );
};

const AccordionTrigger = ({
  className,
  children,
  ...props
}: React.ComponentProps<
  typeof AccordionPrimitive.Trigger
>): React.ReactElement => {
  return (
    <AccordionPrimitive.Header>
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn("flex w-full justify-between items-center", className)}
        {...props}
      >
        {children}
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
};
const AccordionContent = ({
  className,
  children,
  ...props
}: React.ComponentProps<
  typeof AccordionPrimitive.Content
>): React.ReactElement => {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="accordion-content data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden data-[state=open]:overflow-visible text-sm"
      {...props}
    >
      <div className={cn("pt-0 pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
};

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
